import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addGallery } from 'slice/gallerySlice';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const Add = () => {
  const [formData, setFormData] = useState({
    name: '',
    image: null
  });

  const dispatch = useDispatch();

  // ✅ FIX: correct slice name
  const { loading } = useSelector((state) => state.gallery);

  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, type, value, files } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === 'file' ? files[0] : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formDataToSend = new FormData();
    formDataToSend.append('name', formData.name);
    formDataToSend.append('image', formData.image);

    try {
      await dispatch(addGallery(formDataToSend)).unwrap?.();
      toast.success('Gallery added successfully!');
      navigate('/gallery');

      setFormData({
        name: '',
        image: null
      });
    } catch (error) {
      console.error('Gallery add failed:', error);
      toast.error('Failed to add gallery');
    }
  };

  return (
    <div className="container-fluid mt-5">
      <div className="mainheadig mx-4">
        <h4 className="text-white font-weight-bold">Add Gallery</h4>
      </div>

      <form onSubmit={handleSubmit} encType="multipart/form-data">
        <div className="row mx-4">
          {/* ✅ NAME FIELD (DB: name) */}
          <div className="col-sm-12 mt-2">
            <label htmlFor="galleryName" className="adminlables">
              Title
            </label>
            <input
              type="text"
              id="galleryName"
              name="name"
              value={formData.name}
              className="form-control"
              onChange={handleChange}
              required
            />
          </div>

          {/* ✅ IMAGE FIELD (DB: image) */}
          <div className="col-sm-12 mt-4">
            <label htmlFor="galleryImage" className="adminlables">
              Image
            </label>
            <input
              type="file"
              id="galleryImage"
              name="image"
              className="form-control btn-block filebg"
              accept="image/*"
              onChange={handleChange}
              required
            />
          </div>
        </div>

        <div className="mt-4 text-right mx-5">
          <button className="btn addbtn btn-lg" disabled={loading} type="submit">
            {loading ? 'Adding...' : 'Add Gallery'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default Add;
